/**
 * ExtractionDataSection public entry point.
 * Re-exports the container to provide a stable import path.
 * @module features/contracts/components/ExtractionDataSection
 */
export { default } from "./ExtractionDataSectionContainer";
